import request from '@/utils/request'

export function getAttachmentList(data) {
  return request({
    url: '/api/attachment/attachment_list',
    method: 'get',
    params: data
  })
}

export function uploadImgBase64(data) {
  return request({
    url: '/api/upload/upload_img',
    method: 'POST',
    data: data
  })
}

export function saveAttachment(data) {
  return request({
    url: '/api/attachment/save_attachment',
    method: 'POST',
    data: data
  })
}
export function delAttachment(data) {
  return request({
    url: '/api/attachment/del_attachment',
    method: 'POST',
    data: data
  })
}

export function batchDelAttachment(data) {
  return request({
    url: '/api/attachment/batch_del_attachment',
    method: 'POST',
    data: data
  })
}

// `options` is optional so existing callers keep the original request behavior.
export function uploadFile(data, uploadProgress, options = {}) {
  let progressEvent = (progressEvent) => { }
  if (uploadProgress && typeof uploadProgress === 'function') {
    progressEvent = uploadProgress
  }
  return request({
    url: '/api/upload/upload_file',
    headers: {'Content-Type': 'multipart/form-data;charset=UTF-8'},
    method: 'POST',
    data: data,
    onUploadProgress: progressEvent,
    ...options
  })
}

export function generateShareUrl(data) {
  return request({
    url: '/api/attachment/generate_share_url',
    method: 'POST',
    data: data
  })
}

